import axios from 'axios';
import {
  ASSIGN_DEPENDENT_QUESTION_URL,
  CREATE_QUESTION_URL,
  GET_DEPENDENT_QUESTIONS_URL,
  GET_QUESTIONS_IN_PROJECT_URL,
  REORDER_SECTION_QUESTIONS_URL,
  UNASSIGN_QUESTIONS_FROM_SECTION_URL,
  UPDATE_QUESTION_URL,
  get_request_config,
} from '@/utils/system_constants/constant.js';

function parse_json_string(value, fallback = {}) {
  try { return JSON.parse(value); }
  catch { return fallback; }
}

function parse_response_data(response) {
  const raw_data = response?.data ?? response ?? {};

  if (typeof raw_data !== 'string') {
    return raw_data;
  }

  const parsed_data = parse_json_string(raw_data);

  return typeof parsed_data === 'string' ? parse_json_string(parsed_data) : parsed_data;
}

function extract_items(response) {
  const parsed = parse_response_data(response);
  const items = parsed?.data ?? parsed?.results ?? [];

  return Array.isArray(items) ? items : [];
}

export const fetch_questions_in_project = async (payload = {}) => {
  const request_config = get_request_config();
  const response = await axios.post(GET_QUESTIONS_IN_PROJECT_URL, payload, request_config);

  return extract_items(response);
};

export const create_question = async (payload) => {
  const request_config = get_request_config();
  const response = await axios.post(CREATE_QUESTION_URL, payload, request_config);

  return parse_response_data(response);
};

export const assign_dependent_question = async (payload) => {
  const request_config = get_request_config();
  const response = await axios.post(ASSIGN_DEPENDENT_QUESTION_URL, payload, request_config);

  return parse_response_data(response);
};

export const fetch_dependent_questions = async (main_question_id) => {
  const request_config = get_request_config();
  const response = await axios.get(
    GET_DEPENDENT_QUESTIONS_URL,
    {
      ...request_config,
      params: {
        main_question_id: Number(main_question_id),
      },
    }
  );

  return extract_items(response);
};

export const fetch_question_for_edit = async (question_id) => {
  const request_config = get_request_config();
  const response = await axios.put(UPDATE_QUESTION_URL, { question_id }, request_config);

  return parse_response_data(response);
};

export const update_question = async (payload) => {
  const request_config = get_request_config();
  const response = await axios.put(UPDATE_QUESTION_URL, payload, request_config);

  return parse_response_data(response);
};

export const reorder_section_question = async (payload) => {
  const request_config = get_request_config();
  const response = await axios.post(REORDER_SECTION_QUESTIONS_URL, payload, request_config);

  return parse_response_data(response);
};

export const unassign_question_from_section = async (payload) => {
  const request_config = get_request_config();
  const response = await axios.post(UNASSIGN_QUESTIONS_FROM_SECTION_URL, payload, request_config);

  return parse_response_data(response);
};
